import React from 'react';
import styles from './UIGameHelpFullScreenButton.module.scss';
import clsx from 'clsx';
import { useUIGameFullScreenContext } from './UIGameHelpFullScreenContext.tsx';
import IconFullScreenContract from '@static/images/icon_fullscreen_contract.svg';
import IconFullScreenExpand from '@static/images/icon_fullscreen_expand.svg';
export const UIGameHelpFullScreenButton = ({ className })=>{
    const { isFullScreen, toggleFullScreen } = useUIGameFullScreenContext();
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        className: clsx(styles.fullScreenButton, className),
        onClick: toggleFullScreen,
        src: isFullScreen ? IconFullScreenContract : IconFullScreenExpand
    }));
};
